(function (global) {
  'use strict';
  var document = global.document;
  if (document.documentElement.getAttribute('data-loomlac-delivery-adapter') === 'true') return;
  document.documentElement.setAttribute('data-loomlac-delivery-adapter', 'true');
  var settings = Object.assign({ cartUrl: '/cart', cartAddUrl: '/cart/add.js', cartAddTimeoutMs: 12000 }, global.ViolaDeliveryLocationConfig || {});
  var pending = new WeakSet();

  function showError(form, message) {
    var wrapper = form.querySelector('.product-form__error-message-wrapper');
    var text = form.querySelector('.product-form__error-message');
    if (!text) {
      text = document.createElement('p');
      text.setAttribute('role', 'alert');
      form.appendChild(text);
    }
    if (wrapper) wrapper.hidden = false;
    text.textContent = message;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var button = event.submitter;
    if (!form || !button) return;
    if (button.hasAttribute('data-viola-checkout')) {
      if (button.getAttribute('aria-disabled') === 'true' || button.getAttribute('aria-busy') === 'true') {
        event.preventDefault(); event.stopImmediatePropagation(); button.click();
      }
      return;
    }
    if (!button.hasAttribute('data-loomlac-buy-now')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (pending.has(form)) return;
    var body;
    try { body = new global.FormData(form); }
    catch (_error) {
      showError(form, 'راجع اختيارات المنتج وحاول تاني.'); return;
    }
    pending.add(form);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    var abort = typeof global.AbortController === 'function' ? new global.AbortController() : null;
    var timer;
    var timeout = new Promise(function (_resolve, reject) {
      timer = global.setTimeout(function () {
        if (abort) abort.abort();
        reject(new Error('cart_unknown'));
      }, settings.cartAddTimeoutMs);
    });
    // Preserve the actual selected variant, quantity, selling plan and all
    // customization properties/files from the original product form.
    var add = global.fetch(settings.cartAddUrl, {
      method: 'POST', headers: { Accept: 'application/json' }, body: body,
      ...(abort ? { signal: abort.signal } : {})
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) throw new Error('cart_rejected');
      });
    });
    Promise.race([add, timeout]).then(function () {
      global.location.assign(settings.cartUrl);
    }).catch(function (error) {
      if (error && error.message === 'cart_rejected') {
        showError(form, 'مش قادرين نضيف المنتج دلوقتي. راجع الاختيار والكمية وحاول تاني.');
      } else {
        // A lost response does not prove that Shopify rejected the add. Never
        // retry it automatically: inspect the cart instead of adding twice.
        global.location.assign(settings.cartUrl);
      }
    }).finally(function () {
      global.clearTimeout(timer);
      pending.delete(form); button.disabled = false; button.removeAttribute('aria-busy');
    });
  }, true);

  // Craft's drawer/notification must also visit the main cart. Its own normal
  // add-to-cart and quantity handlers remain untouched; no DOM observer/injection.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var trigger = target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
    if (!trigger || trigger.hasAttribute('data-viola-checkout')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    global.location.assign(settings.cartUrl);
  }, true);
})(window);
